/**
 * Il page break è renderizzato solo lato PDF e non è visibile in compilazione
 */
export function PageBreakWidgeComponent() {
  return null;
}
